@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="scorecast-option-group">
    <div #dropdownWrapper class="flex-layout scorecast-option-group-body">
        <div class="scorecast-option-group-col">
            <span class="scorecast-option-group-name">{{ messages.goalScorerTitle }}</span>
            <ms-multi-column-dropdown
                #marketDropdown
                dropdownPlacement="left"
                [groups]="players"
                [active]="selectedPlayer"
                [images]="images"
                [viewport]="dropdownMenuViewport"
                [isFullWidth]="true"
                (optionChange)="onPlayerChange($event)"
                (toggleDropdownState)="onPlayerDropdownClick($event)" />
        </div>
    </div>
    <ms-scorecast-footer
        [optionGroup]="optionGroup"
        [activeEventOption]="activeEventOption"
        [event]="event"
        [warningMessage]="warningMessage"
        [tracking]="tracking"
        [sourceOfPick]="sourceOfPick"
        [betDetails]="betDetails" />
</div>
